/**
 * File: glanceUtils.ts
 * Path: apps/admin/src/features/menu/utils/glanceUtils.ts
 * Description: The wording of the lines at the top of a section's own page: follow-ups due (CRM) and drafts waiting (CMS).
 */

import { formatRand } from "@idk/config";

export interface CrmGlanceSummary {
  followUpsDue: number;
  open: number;
  openValue: number;
}

export const crmGlanceText = (summary: CrmGlanceSummary): { headline: string; detail: string } => ({
  headline:
    summary.followUpsDue === 0
      ? "No follow-ups due today"
      : `${summary.followUpsDue} follow-up${summary.followUpsDue === 1 ? "" : "s"} due today`,
  detail: `${summary.open} open lead${summary.open === 1 ? "" : "s"}${summary.openValue > 0 ? ` worth about ${formatRand(summary.openValue)}` : ""}`,
});

export const countDrafts = (list?: ReadonlyArray<{ status?: string }>): number =>
  (list ?? []).filter((item) => item.status === "draft").length;

export const draftsText = (caseStudies: number, posts: number): string =>
  `${caseStudies} case stud${caseStudies === 1 ? "y" : "ies"}, ${posts} article${posts === 1 ? "" : "s"}`;
